import { PageHead, Chip, Icon } from "../components/ui";

const CONTENT = {
  manager: {
    n: "02", title: "Manager · pilotage", phase: "Phase 4",
    items: [
      ["Missions", "Client → objectif → cible → critères data → volume → opérateurs → script → statuts → validation → lancement."],
      ["Segmentation", "Le moteur de filtres de la Master Data est prêt : mêmes critères, comptages avant validation."],
      ["Attribution", "Équitable, manuelle, rééquilibrage, reprise de portefeuille, redistribution en cas d'absence."],
      ["Planning", "Présence, absence, capacité et charge des opérateurs 1 à 50 et plus."],
    ],
  },
  prospection: {
    n: "03", title: "Prospection · poste opérateur", phase: "Phases 5 et 6",
    items: [
      ["Écran en 3 zones", "Données du lead · contact et action d'appel · script, puis qualification en bas."],
      ["Clôture obligatoire", "« Appel suivant » reste inactif tant que statut, qualification, commentaire et rappel ne sont pas conformes."],
      ["Ringover", "Click-to-call et historique via un adaptateur isolé, construit sur la documentation officielle."],
      ["Enrichissement", "Tout ce que l'opérateur découvre remonte dans la Master Data, avec son historique."],
    ],
  },
  resultats: {
    n: "04", title: "Résultats · cockpit", phase: "Phase 7",
    items: [
      ["Cockpit Leads", "Vue d'ensemble, missions, tendances, équipe et brief du matin, alimentés par le CRM et non plus par Excel."],
      ["Règles reprises", "Rythme attendu, objectif du jour, projection, conseils : recalculés côté serveur."],
      ["Par client", "Chaque client ne voit que son périmètre."],
      ["Transition", "Import du fichier Excel actuel pour comparer chiffre à chiffre pendant la bascule."],
    ],
  },
} as const;

export function Soon({ space }: { space: keyof typeof CONTENT }) {
  const c = CONTENT[space];
  return (
    <main className="page">
      <PageHead eyebrow={`Espace ${c.n}`} title={c.title} right={<Chip tone="purple" dot>{c.phase}</Chip>} />
      <div className="banner info"><Icon name="alert" /> Cet espace s'appuie sur le socle déjà livré (Master Data, droits, historique). Voici ce qu'il contiendra.</div>
      <div className="soon">
        {c.items.map(([t, d]) => (
          <div key={t} className="tile"><h3>{t}</h3><p className="muted" style={{ margin: 0 }}>{d}</p></div>
        ))}
      </div>
    </main>
  );
}
